/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Who_Wc2Inputs */

const en_wc_vs_who_wc2 = /** @type {(inputs: Wc_Vs_Who_Wc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`use Linux, or a mix of operating systems`)
};

/**
* | output |
* | --- |
* | "use Linux, or a mix of operating systems" |
*
* @param {Wc_Vs_Who_Wc2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_who_wc2 = /** @type {((inputs?: Wc_Vs_Who_Wc2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Who_Wc2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_who_wc2(inputs)
});
export { wc_vs_who_wc2 as "wc.vs.who_wc2" }